import { render, staticRenderFns } from "./UserShow.vue?vue&type=template&id=683cc3bc"
import script from "./UserShow.vue?vue&type=script&lang=ts"
export * from "./UserShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports